import HotelStatusIcon from 'components/HotelStatusIcon'
import moment from 'moment'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import { Cell, Row } from '../../../../components/ReusableComponents/Table'
import { formatPrice } from '../../../../utils/common'
import CheckCell from '../../Common/CheckCell'
import HotelIdCell from '../../Common/HotelIdCell'
import HotelNameCell from '../../Common/HotelNameCell'
import useNote from '../../Common/useNote'
import { useNoteBatchLoader } from '../../Common/NoteBatchLoaderContext'
import styles from './PMSBErow.module.scss'

const DoubleCell = ({ primary, secondary, ...props }) => (
  <Cell className={styles.doubleCell} {...props}>
    <div className={styles.doubleCellPrimary}>{primary}</div>
    <div className={styles.doubleCellSecondary}>{secondary}</div>
  </Cell>
)

const GoToBillingAndPayments = ({ subsidiaryId }) => {
  return (
    <Link to={`/s/${subsidiaryId}/billing`}>
      <button>Go to Billing &amp; Payments →</button>
    </Link>
  )
}

const emailTypes = {
  SubsidiaryInvoiceForPayment: 'Payment',
  SubsidiaryInvoiceForReconciliation: 'Reconciliation',
  SubsidiaryInvoiceForPaymentLateMuch: 'Payment late'
}

const BillingRow = ({
  displayId,
  brand,
  shortName,
  isAutoPayEnabled,
  balanceCurrent,
  balanceLate,
  paymentLastReceivedOn,
  paymentLastAmount,
  emailLastContent,
  emailLastSentOn,
  subsidiaryId,
  index,
  subsidiaryStatus,
  rowStatus,
  statusExplanation,
  csmUserFullName
}) => {
  const { registerCallback, notesCache } = useNoteBatchLoader()
  const {
    note,
    setNote,
    isLoading: isLoadingNote,
    isSaving,
    error: noteError,
    loadNoteOnDemand,
    setNoteFromBatch
  } = useNote(subsidiaryId, 'healthCheck-billing', { batchLoad: true })

  // Register callback to receive batch-loaded notes
  useEffect(() => {
    const key = `${subsidiaryId}-healthCheck-billing`
    
    // Check if note is already in cache
    if (notesCache.has(key)) {
      setNoteFromBatch(notesCache.get(key))
    }

    // Register callback for future updates
    const unregister = registerCallback(subsidiaryId, 'healthCheck-billing', (data) => {
      setNoteFromBatch(data)
    })

    return unregister
  }, [subsidiaryId, registerCallback, notesCache, setNoteFromBatch])

  return (
    <div
      className={`${styles.rowHolder} ${rowStatus ? styles[rowStatus] : ''}`}
      title={statusExplanation}
    >
      <div className={styles.statusIcon}>
        <HotelStatusIcon status={subsidiaryStatus} />
      </div>
      <div className={styles.index}>{index}</div>
      <Row>
        <HotelIdCell displayId={displayId} />
        <HotelNameCell
          brand={brand}
          name={shortName}
          navigationControl={<GoToBillingAndPayments subsidiaryId={subsidiaryId} />}
        />
        <Cell className={styles.textCell}>
          <span title={csmUserFullName}>
            {csmUserFullName
              ?.split(' ')
              .map(str => str[0])
              .join('.')}
          </span>
        </Cell>
        <CheckCell isChecked={isAutoPayEnabled} />
        <Cell className={styles.textCell}>{formatPrice(balanceCurrent)}</Cell>
        <Cell className={styles.textCell}>{formatPrice(balanceLate)}</Cell>
        <DoubleCell primary={formatPrice(paymentLastAmount)} />
        <Cell className={styles.textCell}>
          {moment(paymentLastReceivedOn).format('MMM DD, YYYY')}
        </Cell>
        <DoubleCell
          primary={emailTypes[emailLastContent]}
          secondary={moment(emailLastSentOn).format('MMM DD, YYYY')}
        />
        <Cell className={styles.noteCell}>
          <input
            type="text"
            value={note}
            onChange={e => setNote(e.target.value)}
            onFocus={loadNoteOnDemand}
            placeholder=" "
            disabled={isLoadingNote}
          />
          {isSaving && <span className={styles.savingIndicator}>Saving...</span>}
          {noteError && <div className={styles.noteError}>{noteError}</div>}
        </Cell>
      </Row>
    </div>
  )
}

export default BillingRow
